<template>
  <div>
    <div v-if="!!clientChange || !!aiInProgress"
         style="position: absolute; top: 0; left: 0; width: 10000px; height: 10000px; z-index:10000; background: whitesmoke; opacity: 0.5;"></div>
    <div v-if="aiInProgress" class="blocker-backdrop"><h3 class="blocker-text">Automatische
      Übersetzung läuft.
      Die Bearbeitung ist gesperrt: {{ aiProgress }}%</h3></div>
    <vue-toastr ref="notificationToast"></vue-toastr>
    <div class="ibox box-primary">
      <div
          style="text-align: center; margin: 0 0 0 -25px;font-weight: bold; position: fixed; top: 0; height: 165px;  background: white; border-bottom: 1px solid black; z-index: 1000; width: 100%;">
        <div style="height: 10px">
        </div>
        <div class="col-md-12">
          <button class="btn btn-primary col-md-5" style="margin: 5px" :disabled="saving || !!loading || aiInProgress"
                  @click="checkTranslations">
            Übersetzungen auf Vollständigkeit prüfen
          </button>
          <div class="col-md-4">
            <input type="Search"
                   id="search_text"
                   placeholder="Nach Originaltext oder Übersetzung suchen..." class=" form-control" style="margin: 5px"
                   v-on:keyup.enter="search">
          </div>
        </div>
        <div class="col-md-12">
          <button v-if="aiTranslationAvailable" class="btn btn-secondary col-md-4" style="margin: 5px"
                  :disabled="saving || !!loading || aiInProgress"
                  @click="startAIUpdate">
            {{
              aiInProgress ? 'Automatische Übersetzung läuft...' : 'Vollständige automatische Übersetzung auf alle Sprachen anwenden'
            }}
          </button>
          <button v-if="aiTranslationAvailable" class="btn btn-secondary col-md-5" style="margin: 5px"
                  :disabled="saving || !!loading || aiInProgress"
                  @click="startAIUpdateCurrentLanguage">
            {{
              aiInProgress ? 'Automatische Übersetzung läuft...' : 'Vollständige automatische Übersetzung auf die gewählte Sprache anwenden'
            }}
          </button>
        </div>
        <div class="col-md-12">
          <div class="col-md-3" style="margin: 3.3px">
            <button class="btn button-success" style="background: white">
              Sprache für Übersetzung wählen:
            </button>
          </div>
          <div class="col-md-3" style="margin: 3.3px">
            <Select2 :settings="selectSettings" v-model="currentLanguage" :options="languages"
                     :disabled="!!loading || aiInProgress"/>
          </div>
          <button class="btn btn-success col-md-3" style="margin: 3.3px"
                  :disabled="saving || !!loading || aiInProgress" @click="updatePathsAndFiles">
            {{ saving ? 'Wird gespeichert...' : 'Übersetzungen speichern' }}
          </button>
        </div>

      </div>
      <div style="margin-bottom: 50px">

      </div>
      <div class="ibox-content">
        <div v-if="isAdmin" class="form-group">
          <h3 class="control-label">Mandant</h3>
          <Select2 v-model="clientId" :options="clients" @change="onClientChange" :disabled="!!loading"/>
        </div>
        <br>
        <h3>Texte aus der App Sprachdatei</h3>
        <div v-if="!!loading" style="text-align: center">
          Übersetzungen werden geladen
          <i id='tag-spinner' class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </div>
        <div v-if="!loading">
          <div class="col-md-12 row"
               style=" margin-left:5px; padding: 5px; border-bottom: solid #e5e5e5 1px; margin-top: 10px">
          </div>
          <div v-for="title in Object.keys(collapsiblesFiles)">
            <button class="btn btn-secondary" type="button" data-toggle="collapse"
                    :data-target="'#collapse_app_'+title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, '')"
                    aria-expanded="false" :aria-controls="'collapse_app_'+title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, '')"
                    style="width: 100%; text-align: left">
              <h3 class="box-title">
                Originaltext: {{ title }} <i class="fa fa-chevron-down"
                                             aria-hidden="true"></i>
              </h3>
            </button>
            <div class="collapse" :id="'collapse_app_'+title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, '')">
              <div class="card card-body" style="margin-left: -5px">
                <div v-for="(path,index) in collapsiblesFiles[title]" :key="path">
                  <div v-for="iso in Object.keys(files[appIds[title]][path])" :key="iso">
                    <div v-if="iso === currentLanguage">
                      <div class="col-md-12 row"
                           :style=" 'margin-left:5px; padding: 5px; border: solid #e5e5e5 1px; border-bottom: none; border-top:none;' + (index % 2=== 0 ? 'background:white;' : 'background:#f8f8f8;')">
                        <div class="col-md-4" style=" display: table-cell; vertical-align: middle;">
                          <p>{{ defaultFiles[path] }}</p>
                        </div>
                        <div class="col-md-5">
                    <textarea :name="appIds[title]+'_'+path+'_'+iso"
                              :id="appIds[title]+'_'+path+'_'+iso"
                              :disabled="!enabled[appIds[title]+'_'+path+'_'+iso]"
                              v-model="files[appIds[title]][path][iso]"
                              class="form-control"
                              :style="'height: 100%; resize: none; margin: 0; box-sizing: border-box;'+( Object.hasOwn(missing,appIds[title]+path+iso) ? 'border: #5ba366 solid 2px;' : '')"></textarea>
                        </div>
                        <button
                            v-tippy="{ content: getTooltip(path,iso) }"
                            class="btn btn-success col-md-2" style="margin-left: -5px; "
                            v-html="'<ion-icon name=\'create-outline\'></ion-icon>' + (enabled[appIds[title]+'_'+path+'_'+iso] ? 'Sperren' : 'Bearbeiten')"
                            @click="enabled[appIds[title]+'_'+path+'_'+iso] = !enabled[appIds[title]+'_'+path+'_'+iso]; $forceUpdate();">
                        </button>
                        <button class="btn btn-secondary col-md-1"
                                style="margin-left: 5px; margin-right: -20px; background:lightgrey; color: black; border: solid 1px #d1d1d1;"
                                @click="updateSingleFile(files[appIds[title]][path][defaultLanguage],defaultLanguage,currentLanguage,path,appIds[title])"
                                :aria-disabled="!!translating"
                                v-tippy="{ content: 'Automatische Übersetzung für dieses Feld anwenden.'}">
                          <ion-icon name="globe-outline"></ion-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <br>
          </div>
          <div class="col-md-12 row"
               style=" margin-left:5px; padding: 5px; border-top: solid #e5e5e5 1px; margin-bottom: 30px">
          </div>
        </div>
        <h3>Texte aus dem smart.KIS App-Customizing</h3>
        <div v-if="!!loading" style="text-align: center">
          Übersetzungen werden geladen
          <i id='tag-spinner' class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </div>
        <div v-if="currentLanguage === defaultLanguage"
             style="border: #1f90d8 1px solid; background: #e1f0ff; padding: 5px; margin:15px; border-radius: 5px">
          Die folgenden Originaltexte stammen aus dem App-Customizing und können dort bearbeitet werden.
        </div>
        <div v-if="!loading">
          <div v-for="title in Object.keys(collapsiblesPath)">
            <button class="btn btn-secondary" type="button" data-toggle="collapse"
                    :data-target="'#collapse_'+(title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, ''))"
                    aria-expanded="false" :aria-controls="'collapse_'+(title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, ''))"
                    style="width: 100%; text-align: left">
              <h3 class="box-title">
                {{
                  title.includes('Email') ? 'Originaltext: ' + title.replace('Email', 'E-Mail') : 'Originaltext im App-Customizing: ' + (title === 'Info' ? 'Info-Slider' : title)
                }} <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </h3>
            </button>
            <div class="collapse" :id="'collapse_'+(title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, ''))">
              <div class="card card-body" style="margin-left: -5px">
                <div v-if="title.includes('Email') ">
                  <br>
                  <div
                      style="border-radius: 5px; padding: 8px; background: #fffdf8; border: 1px solid #e3cf7c; margin: 10px"
                      v-if="currentLanguage === defaultLanguage">
                    Keine Überschreibung der deutschen Texte möglich. Für Änderungen der E-Mail Templates wenden Sie
                    sich bitte an den Support.
                  </div>
                  <br>
                  <div v-html="editorVariablesExplanation">
                  </div>
                  <br>
                </div>
                <div v-for="(path, index) in collapsiblesPath[title]" :key="path">
                  <div
                      style="border-radius: 5px; padding: 8px; background: #fffdf8; border: 1px solid #e3cf7c; margin: 10px"
                      v-if="currentLanguage === defaultLanguage && index === 0 && !!Object.keys(links).find(v => atob(path).startsWith(v))">
                    Keine Überschreibung der deutschen Texte möglich. Bitte bearbeiten Sie den Originaltext unter
                    App-Customizing. <a
                      :href="links[Object.keys(links).find(v => atob(path).startsWith(v))]"
                      class="btn btn-success" style="margin-left: 5px">Zum Abschnitt App Customizing:
                    {{ title === 'Info' ? 'Info-Slider' : title }}</a>
                  </div>
                  <div v-for="iso in Object.keys(paths[path])" :key="iso">
                    <div v-if="paths[path][defaultLanguage].trim() !== 'Neues Element'" :class="iso === currentLanguage ? '' : 'hidden'">
                      <div class="col-md-12 row"
                           :style=" 'margin-left:5px; padding: 5px; border: solid #e5e5e5 1px; border-bottom: none;' + (typeof descriptionsTitles[path] !== 'undefined' ? '' : 'border-top:none;') + (index % 2 === 0 ? 'background:#f8f8f8;' : 'background:white;')">
                        <div v-if="typeof descriptionsTitles[path] !== 'undefined'" class="col-md-12"><h3>
                          {{ descriptionsTitles[path] }}</h3></div>
                        <div class="col-md-12" style="font-weight: bold">{{ descriptions[path] }}</div>
                        <div class="col-md-4" style=" display: table-cell; vertical-align: middle;">
                          <div
                              v-html="!paths[path][defaultLanguage].trim() ? '<i>Kein Inhalt vorhanden</i>' : paths[path][defaultLanguage].replace(/\n/g, '').replace(/\r/g, '')"
                              style="white-space:pre-wrap;"></div>
                        </div>
                        <div v-if="fieldTypes[path] === 'default'" class="col-md-5"><textarea :name="path+'_'+iso"
                                                                                              :id="path+'_'+iso"
                                                                                              :readonly="!enabled[path+'_'+iso]"
                                                                                              v-model="paths[path][iso]"
                                                                                              class="form-control"
                                                                                              :style="'height: 100%; resize: none; margin: 0; box-sizing: border-box;'+(Object.hasOwn(missing,path+iso) ? 'border: #71bfb6 solid 2px;' : '')"></textarea>
                        </div>
                        <div v-if="fieldTypes[path] === 'html'" class="col-md-5">

                          <ckeditor v-if="iso !== defaultLanguage"
                                    :config="editorConfig"
                                    :name="path+'_'+iso"
                                    :id="path+'_'+iso"
                                    v-model="paths[path][iso]"
                                    class="form-control"
                                    :style="'height: 100%; resize: none; margin: 0; box-sizing: border-box; '+(Object.hasOwn(missing,path+iso) ? 'border: #71bfb6 solid 2px;' : '')"></ckeditor>
                          <div v-if="iso === defaultLanguage"
                               v-html="paths[path][defaultLanguage].replace(/\n/g, '').replace(/\r/g, '')"
                               style="white-space:pre-wrap;"></div>
                        </div>
                        <button class="btn btn-success col-md-2"
                                v-tippy="{ content: getTooltip(path,iso) }"
                                v-html="currentLanguage === defaultLanguage ? 'Bearbeitung blockiert' : ('<ion-icon name=\'create-outline\'></ion-icon>' + (enabled[path+'_'+iso] ? 'Sperren' : 'Bearbeiten'))"
                                @click="enabled[path+'_'+iso] = !enabled[path+'_'+iso]; $forceUpdate();"
                                :disabled="currentLanguage === defaultLanguage">
                        </button>
                        <button class="btn btn-secondary col-md-1"
                                style="margin-left: 5px; margin-right: -20px; background:lightgrey; color: black; border: solid 1px #d1d1d1;"
                                @click="updateSinglePath(paths[path][defaultLanguage],defaultLanguage,currentLanguage,path)"
                                :aria-disabled="!!translating"
                                v-tippy="{ content: 'Automatische Übersetzung für dieses Feld anwenden.'}">
                          <ion-icon name="globe-outline"></ion-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 row"
                     style=" margin-left:5px; padding: 5px; border-top: solid #e5e5e5 1px; margin-bottom: 30px">
                </div>
              </div>
            </div>
            <br>
            <br>
          </div>
        </div>
      </div>
      <translation-modal-single-choice ref="translationModalSingleChoice"/>
      <translation-modal-confirm ref="translationModalConfirm"/>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import Spinner from "../common/spinner/Spinner";
import draggable from 'vuedraggable'
import translationModalSingleChoice from "./modal/TranslationModalSingleChoice.vue";
import translationModalConfirm from "./modal/TranslationModalConfirm.vue";

export default {
  name: 'AppTranslationForm',
  components: {
    Spinner,
    Modal,
    VueToastr,
    draggable,
    translationModalSingleChoice,
    translationModalConfirm
  },
  async mounted() {
    console.log(this.editorVariables);
    this.loading = true;
    let newPaths = {};
    let newFieldTypes = {};
    let newDescriptions = {};
    let modelNames = {};

    for (let model of this.paths) {
      for (let attribute of model.attributes) {
        modelNames[attribute.path] = model.name;
        newPaths[attribute.path] = attribute.value;
        newFieldTypes[attribute.path] = attribute.form;
        newDescriptions[attribute.path] = attribute.name;
      }
    }

    this.descriptions = newDescriptions;
    this.fieldTypes = newFieldTypes;
    this.paths = newPaths;

    //@ionic/vue is only supported on Vue3+ so we add some spaghetti here
    let scr = document.createElement('script')
    scr.setAttribute('src', 'https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js')
    scr.setAttribute('type', 'module')
    document.head.appendChild(scr)

    scr = document.createElement('script')
    scr.setAttribute('src', 'https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js')
    scr.setAttribute('nomodule', '')
    document.head.appendChild(scr)

    await this.getTranslations();
    this.saving = false;

    let lastTitle = '';
    this.collapsiblesFiles = {};
    this.collapsiblesPath = {};
    this.appIds = {};
    let modelNameFound = {};
    let newDescriptionsTitles = {};

    for (let app_id of Object.keys(this.files)) {
      for (let path of Object.keys(this.files[app_id])) {
        let title = this.fromCaps(path.substring(0, path.indexOf(".")).trim()) + ` (${this.apps[app_id]} - ID ${app_id})`;
        if (title !== lastTitle) {
          lastTitle = title;
          if (!this.collapsiblesFiles[title]) {
            this.collapsiblesFiles[title] = [];
          }
          this.appIds[title] = Number.parseInt(app_id);
        }
        this.collapsiblesFiles[title].push(path);
      }
    }

    lastTitle = '';

    for (let path of Object.keys(this.paths)) {
      let name = modelNames[path];

      let title = name.substring(0, name.indexOf("-")).trim();
      if (title !== lastTitle) {
        lastTitle = title;
        this.collapsiblesPath[title] = [path];
      } else {
        this.collapsiblesPath[title].push(path);
      }
      if (modelNameFound[name] === true) continue;
      modelNameFound[name] = true;
      newDescriptionsTitles[path] = name;
    }

    this.descriptionsTitles = newDescriptionsTitles;
    this.loading = false;

    setTimeout(() => {
      this.navigateToSearchPath()
    }, 100);

    await this.checkAIProgress();

    this.$nextTick(() => {
      $('.collapse').collapse('hide');
      $('li[permissions="app_customizing.read"]').removeClass('active');
    });

    setInterval(async () => {
      await this.checkAIProgress();
    }, 500);
  },
  props: ['aiTranslationAvailable', 'editorVariablesExplanation', 'links', 'missing', 'apps', 'timestamps', 'editorVariables', 'appIds', 'collapsiblesFiles', 'collapsiblesPath', 'checking', 'checkAIProgress', 'searchPath', 'currentLanguage', 'languages', 'clientChange', 'loading', 'defaultLanguage', 'clientId', 'descriptions', 'descriptionsTitles', 'fieldTypes', 'paths', 'files', 'defaultFiles', 'isAdmin', 'originalPaths', 'originalFiles', 'clients', 'enabled', 'saving', 'translating', 'aiInProgress', 'aiProgress'],
  data() {
    return {
      currentSearchSkip: 0,
      currentSearch: '---',
      selectSettings: {
        escapeMarkup: markup => markup,
        templateResult: data => {
          if (!data.id) return data.text
          return data.text
        },
        templateSelection: data => data.text
      },
      editorConfig: {
        height: '100%',
        versionCheck: false,
        caseSensitive: true,
        autoParagraph: false,
        enterMode: 2,
        shiftEnterMode: 2,
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'EmojiPanel'],
          ['Undo', 'Redo', 'RemoveFormat'],
          ['Link', 'Unlink'],
          ['NumberedList', 'BulletedList']
        ],
        extraPlugins: ['emoji', 'mentions'],
        mentions: [
          {
            feed: this.editorVariables,
            minChars: 0,
            marker: '@'
          }
        ],
        emoji_followingSpace: true
      }
      ,
      toolbar: [
        ["bold", "italic", "underline"],
        ["link", "clean"]
      ],
    }
  },
  methods: {
    async showPopup(title, text, buttonText) {
      return await this.$refs.translationModalSingleChoice.open(
          title,
          text,
          buttonText
      )
    },
    async showConfirm(title, text, noButtonText, yesButtonText) {
      return await this.$refs.translationModalConfirm.open(
          title,
          text,
          noButtonText,
          yesButtonText
      )
    },
    atob(data) {
      return window.atob(data);
    },
    onClientChange() {
      if (typeof window !== 'undefined') {
        this.clientChange = true;
        window.location = '/backend/app_translations/index?client_id=' + this.clientId;
      }
    },
    navigateToSearchPath() {
      if (this.searchPath === null || this.searchPath === 'null') return;

      this.$forceUpdate();
      let element = null;
      let counter = 0;
      while (!element && counter < 7) {
        element = document.querySelector('[id*="' + this.searchPath + '"]');
        this.searchPath = this.searchPath.substring(0, this.searchPath.length - 1);
        counter++;
      }

      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    },
    async checkAIProgress() {
      if (!!this.checking) return;

      try {
        let response = await axios.get('/backend/app_ai_translations/' + this.clientId);

        if (response.data.message === 'update in progress') {
          this.aiInProgress = true;
          this.aiProgress = response.data.progress;
        } else {
          this.aiInProgress = false;
        }
      } finally {
        this.checking = false;
      }
    },
    checkTranslations() {
      let missingTotal = 0;
      let missing = {};

      for (let app_id of Object.keys(this.files)) {
        for (let path of Object.keys(this.files[app_id])) {
          if (!this.files[app_id][path]?.[this.defaultLanguage]?.trim()) continue;
          for (let iso of Object.keys(this.files[app_id][path])) {
            if (!this.files[app_id][path][iso].trim()) {
              missingTotal++;
              for (let iso2 of Object.keys(this.files[app_id][path])) {
                missing[app_id + path + iso2] = 1;
              }
            }
          }
        }
      }

      for (let path of Object.keys(this.paths)) {
        if (!this.paths[path][this.defaultLanguage]?.trim()) continue;
        for (let iso of Object.keys(this.paths[path])) {
          if (!this.paths[path][iso].trim()) {
            missingTotal++
            for (let iso2 of Object.keys(this.paths[path])) {
              missing[path + iso2] = 1;
            }
          }
        }
      }

      if (Object.keys(missing).length > 0) {
        this.showPopup('Übersetzungen auf Vollständigkeit geprüft', 'Es wurden ' + missingTotal + ' fehlende Übersetzungen gefunden. Bitte überprüfen Sie alle markierten Felder und füllen Sie für jede Sprache eine Übersetzung aus.', 'Schließen');
      } else {
        this.showPopup('Übersetzungen vollständig!', 'Es wurden keine fehlenden Übersetzungen gefunden.', 'Schließen');
      }

      this.missing = missing;
    },
    async search() {
      let search = document.getElementById('search_text');
      let searchText = search.value.toLowerCase();

      console.log(this.currentSearchSkip);

      if (searchText !== this.currentSearch || this.currentSearch === '---') {
        this.currentSearch = searchText;
        this.currentSearchSkip = 0;
      } else {
        this.currentSearchSkip++;
      }

      let skip = 0;

      for (let title of Object.keys(this.collapsiblesFiles)) {
        for (let path of this.collapsiblesFiles[title]) {
          for (let iso of Object.keys(this.files[this.appIds[title]][path])) {
            if (this.files[this.appIds[title]][path][iso].toLowerCase().includes(searchText)) {
              if (skip < this.currentSearchSkip) {
                skip++;
                continue;
              }
              this.currentLanguage = iso;
              this.$forceUpdate();
              $('#collapse_app_' + title.replace(/[ \-\(\)\&\:\.\,\#\+]/g, "")).collapse('show');
              await this.$nextTick()
              await this.$nextTick()
              let element = document.getElementById(this.appIds[title] + '_' + path + '_' + iso);
              element.style.border = '#1f90d8 solid 2px';
              element.style.borderRadius = '2px';
              setTimeout(() => {
                element.style.border = '';
                element.style.borderRadius = '0';
              }, 1500);
              element.scrollIntoView({behavior: 'instant', block: 'center'});
              return;
            }
          }
        }
      }

      for (let path of Object.keys(this.paths)) {
        for (let iso of Object.keys(this.paths[path])) {
          if (this.paths[path][iso].toLowerCase().includes(searchText)) {
            if (skip < this.currentSearchSkip) {
              skip++;
              continue;
            }
            this.currentLanguage = iso;
            this.$forceUpdate();
            for (let title of Object.keys(this.collapsiblesPath)) {
              if (this.collapsiblesPath[title].includes(path)) {
                $('#collapse_' + (title.replace(/[ \-\(\)\.\&\,\:\#]/g, ""))).collapse('show');
              }
            }
            await this.$nextTick()
            await this.$nextTick()
            let element = document.getElementById(path + '_' + iso);
            element.style.border = '#1f90d8 solid 2px';
            element.style.borderRadius = '2px';
            setTimeout(() => {
              element.style.border = '';
              element.style.borderRadius = '0';
            }, 1500);
            element.scrollIntoView({behavior: 'instant', block: 'center'});
            return;
          }
        }
      }

      if (skip > 0) {
        this.currentSearch = '---';
        await this.search();
      }
    },
    async startAIUpdate() {

      if (!await this.showConfirm('Automatische Übersetzung generieren', 'Möchten Sie die automatische Übersetzung <b>auf alle Felder in allen Sprachen</b> für die Texte in der App anwenden? Individuelle Übersetzungen gehen dadurch verloren und werden von der automatischen Übersetzung überschrieben.', 'Abbrechen', 'Automatische Übersetzung starten')) {
        return;
      }

      this.aiInProgress = true;

      this.$forceUpdate();

      await this.checkAIProgress();

      if (this.aiInProgress) return;

      this.aiInProgress = true;

      this.$forceUpdate();

      await axios.put('/backend/app_ai_translations/' + this.clientId, {});

      this.aiInProgress = true;

      await this.showPopup('Automatische Übersetzung', 'Die automatische Übersetzung wurde abgeschlossen. Seite wird nun neu geladen.', 'OK');

      window.location = '/backend/app_translations/index?client_id=' + this.clientId;
    },
    async startAIUpdateCurrentLanguage() {

      if (!await this.showConfirm('Automatische Übersetzung generieren', 'Möchten Sie die automatische Übersetzung <b>auf alle Felder in der Sprache ' + (this.languages.find(language => language.id === this.currentLanguage)?.text) + '</b> für die Texte in der App anwenden? Individuelle Übersetzungen gehen dadurch verloren und werden von der automatischen Übersetzung überschrieben.', 'Abbrechen', 'Automatische Übersetzung starten')) {
        return;
      }

      this.aiInProgress = true;

      await this.checkAIProgress();

      if (this.aiInProgress) return;

      this.aiInProgress = true;

      this.$forceUpdate();

      await axios.put('/backend/app_ai_translations/' + this.clientId + '?languageCode=' + this.currentLanguage, {});

      this.aiInProgress = false;

      await this.showPopup('Automatische Übersetzung', 'Die automatische Übersetzung wurde abgeschlossen. Seite wird nun neu geladen.', 'OK');

      window.location = '/backend/app_translations/index?client_id=' + this.clientId;
    },
    async getTranslations() {
      let response = await axios.post('/backend/app_translations/paths', {
        paths: this.paths,
        client_id: this.clientId
      });

      let data = response.data
      this.paths = data.paths;
      this.files = data.files;
      this.defaultFiles = data.defaultFiles;
      this.timestamps = data.timestamps;
      console.log(this.timestamps);
      this.apps = data.apps;
      this.links = data.links;
      this.originalPaths = JSON.parse(JSON.stringify(this.paths));
      this.originalFiles = JSON.parse(JSON.stringify(this.files));
    },
    htmlEntityDecode(str) {
      const txt = document.createElement("textarea");
      txt.innerHTML = str;
      return txt.value;
    },
    getTooltip(path, iso) {
      let tooltip = this.timestamps?.[path]?.[iso];
      if (!tooltip) tooltip = 'Letzte Änderung wurde automatisch am ' + new Date().toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }) + ' generiert.';
      return tooltip;
    },
    getDifferencePaths(original, current) {
      //CKEDITOR FIX
      for (let path of Object.keys(original)) {
        if (this.fieldTypes[path] === 'html') {
          for (let iso of Object.keys(original[path])) {
            console.log(path + '_' + iso);
            let element = document.getElementById(path + '_' + iso);
            if(!element) continue;
            let childElement = element.lastElementChild;
            let id = childElement.id.split('_')[1];
            console.log(id);
            current[path][iso] = this.htmlEntityDecode(CKEDITOR.instances[id].getData())
          }
        }
      }

      let difference = {};
      for (let key of Object.keys(original)) {
        for (let iso of Object.keys(original[key])) {
          if (original[key][iso] !== current[key][iso]) {
            if (!difference[key]) difference[key] = {};
            difference[key][iso] = current[key][iso];
          }
        }
      }
      return difference;
    },
    fromCaps(str) {
      return str
          .toLowerCase()
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    },
    getDifferenceFiles(original, current) {
      let difference = {};
      for (let app_id of Object.keys(original)) {
        for (let path of Object.keys(original[app_id])) {
          for (let iso of Object.keys(original[app_id][path])) {
            if (original[app_id][path][iso] !== current[app_id][path][iso]) {
              if (!difference[app_id]) difference[app_id] = {};
              if (!difference[app_id][path]) difference[app_id][path] = {};
              difference[app_id][path][iso] = current[app_id][path][iso];
            }
          }
        }
      }
      return difference;
    },
    async updateSinglePath(text, sourceIso, targetIso, path) {

      if (!await this.showConfirm('Automatische Übersetzung', 'Möchten Sie die automatische Übersetzung <b>in der Sprache ' + (this.languages.find(language => language.id === this.currentLanguage)?.text) + ' für dieses Feld</b> in der App anwenden? Vorherige Eingaben in diesem Feld gehen verloren und werden von der automatischen Übersetzung überschrieben', 'Abbrechen', 'Automatische Übersetzung starten')) {
        return;
      }

      this.translating = true;
      console.log("AI translation: " + text + "-" + sourceIso + "-" + targetIso);
      try {
        let response = await axios.post("/backend/app_ai_translations/store", {
          text,
          targetIso,
          sourceIso,
          path
        });
        if (response.status === 200) this.paths[path][targetIso] = response.data;
      } finally {
        this.translating = false;
      }
    },
    async updateSingleFile(text, sourceIso, targetIso, file, app_id) {

      if (!await this.showConfirm('Automatische Übersetzung', 'Möchten Sie die automatische Übersetzung <b>in der Sprache ' + (this.languages.find(language => language.id === this.currentLanguage)?.text) + ' für dieses Feld</b> in der App anwenden? Vorherige Eingaben in diesem Feld gehen verloren und werden von der automatischen Übersetzung überschrieben', 'Abbrechen', 'Automatische Übersetzung starten')) {
        return;
      }

      this.translating = true;
      console.log("AI translation: " + text + "-" + sourceIso + "-" + targetIso);
      try {
        let response = await axios.post("/backend/app_ai_translations/store", {
          text,
          targetIso,
          sourceIso,
          path: file
        });
        if (response.status === 200) this.files[app_id][file][targetIso] = response.data;
        console.log(response, this.files[app_id][file][targetIso]);
      } finally {
        this.translating = false;
      }
    },
    async updatePathsAndFiles() {

      this.saving = true;
      let paths = this.getDifferencePaths(this.originalPaths, this.paths);
      let files = this.getDifferenceFiles(this.originalFiles, this.files);

      console.log(this.originalPaths, this.paths, paths);

      axios.post("/backend/app_translations/" + this.clientId, {
        paths,
        files
      })
          .then((response) => {
            this.saving = false;
            alert('Speichern erfolgreich.');
            this.originalPaths = JSON.parse(JSON.stringify(this.paths));
            this.originalFiles = JSON.parse(JSON.stringify(this.files));
          })
          .catch((error) => {
            this.saving = false;
            alert('Übersetzungen konnten nicht gespeichert werden, bitte wenden sie sich an den Support.');
          });
    }
  }
}
</script>


<style scoped>
.blocker-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.blocker-text {
  background: white;
  padding: 24px 32px;
  border-radius: 16px;
  border: 1px solid black;
  min-width: 700px;
  max-width: 700px;
  text-align: center;
  z-index: 10002;
  color: black;
}

.collapsing {
  -webkit-transition: none !important;
  transition: none !important;
}
</style>